<template>
  <div class="w-full h-full flex items-center justify-center">
    <div class="content">
      <img
        :src="displayImage"
        alt="Info Image"
        class="w-[200px] aspect-square"
      />
      <div class="info">
        <span class="text-lg font-semibold">{{ $t(displayTitle) }}</span>
        <p class="text-[15px] leading-normal text-muted-foreground pb-2">
          {{ $t(displayDescription) }}
        </p>
        <slot name="action"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import img404 from "@/assets/graphics/404.png";

export default {
  name: "InfoCard",
  props: {
    image: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
  },
  computed: {
    displayTitle() {
      return this.title || "404";
    },
    displayDescription() {
      return this.description || "Страница, которую вы ищете, не найдена.";
    },
    displayImage() {
      return this.image || img404;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  @apply w-[600px] flex flex-col items-center justify-center py-6 gap-2 bg-card rounded-3xl;

  .info {
    @apply max-w-[450px] flex flex-col items-center text-center pb-6 gap-4;
  }
}
</style>
